/**
 * Created by sisy on 2017/8/23.
 */
import state from './state'
import mutations from './mutations'
import actions from './actions'
import {getters} from './state'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
